// extracted by mini-css-extract-plugin
export default {"root":"MeetingReminder_root__C7xH5","meetingButton":"MeetingReminder_meetingButton__kshbw"};